module.exports = __webpack_public_path__ + "static/media/spa-dae.e7801542.png";